"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.progressTimeIndicatorTemplate = exports.progressTemplate = void 0;
var tslib_1 = require("tslib");
var progress_dot_1 = (0, tslib_1.__importDefault)(require("./progress.dot"));
var progressTimeIndicator_dot_1 = (0, tslib_1.__importDefault)(require("./progressTimeIndicator.dot"));
var progressTemplate = progress_dot_1.default.default ? progress_dot_1.default.default : progress_dot_1.default;
exports.progressTemplate = progressTemplate;
var progressTimeIndicatorTemplate = progressTimeIndicator_dot_1.default.default
    ? progressTimeIndicator_dot_1.default.default
    : progressTimeIndicator_dot_1.default;
exports.progressTimeIndicatorTemplate = progressTimeIndicatorTemplate;
//# sourceMappingURL=index.js.map